module.exports = __webpack_public_path__ + "img/csal.9f093fb9.png";